import React, {useEffect, useState} from 'react';
import {SENSITIVE_DATA_PLACEHOLDER} from "../../AppConst";
import Spinner from "../../utils/Spinner/Spinner";
import styles from "./MerchantListComponent.module.css";
import {useLocation} from "react-router-dom";

import {MerchantResponse} from "../../api/MerchantsApi";

type MerchantRowProps = {
    merchant: MerchantResponse;
    onSelect: (merchant: MerchantResponse) => void;
    isSelected: boolean;
};

const MerchantRow: React.FC<MerchantRowProps> = ({
                                                     merchant,
                                                     onSelect,
                                                     isSelected,
                                                 }) => {
    return (
        <tr key={merchant.merchantId} onClick={() => onSelect(merchant)} style={{cursor: "pointer"}}>
            <td>
                <input
                    type="radio"
                    name="selected-merchant"
                    checked={isSelected}
                    onChange={() => onSelect(merchant)}
                />
            </td>
            <td>{merchant.merchantId}</td>
            <td>{SENSITIVE_DATA_PLACEHOLDER}</td>
            <td>{merchant.reportApiKey ? SENSITIVE_DATA_PLACEHOLDER : ''}</td>
            <td>{merchant.clientKey ? SENSITIVE_DATA_PLACEHOLDER : ''}</td>
            <td>{merchant.adyenPrefix}</td>
        </tr>
    );
};

type MerchantListProps = {
    merchants: MerchantResponse[];
    selectedMerchant: MerchantResponse | null;
    setSelectedMerchant: (merchant: MerchantResponse | null) => void;
    fetchMerchants: () => void;
    onAddMerchant: () => void;
    onEdit: () => void;
    onDelete: () => void;
    onViewConfig: () => void;
    onTestConnection: () => void;
};

const MerchantListComponent: React.FC<MerchantListProps> = ({
                                                                merchants,
                                                                selectedMerchant,
                                                                setSelectedMerchant,
                                                                fetchMerchants,
                                                                onAddMerchant,
                                                                onEdit,
                                                                onDelete,
                                                                onViewConfig,
                                                                onTestConnection
                                                            }) => {
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    useEffect(() => {
        const loadMerchants = async () => {
            setLoading(true);
            fetchMerchants();
            setLoading(false);
        };

        loadMerchants();
    }, [fetchMerchants]);

    useEffect(() => {
        if (location.pathname === '/') {
            setSelectedMerchant(null);
        }
    }, [location.pathname, setSelectedMerchant]);

    if (loading) {
        return <Spinner/>;
    }


    if (merchants.length === 0) {
        return <>
            <nav className={styles.headerNav}>
                {renderButton("Add Merchant", onAddMerchant)}
            </nav>
            <p>No merchants available. Please add a merchant to see details here.</p>
        </>;
    }

    return (
        <>
            <nav className={styles.headerNav}>
                {location.pathname !== "/error" &&
                    location.pathname !== '/reset-password' && (
                        <>
                            {location.pathname === '/' && renderButton("Add Merchant", onAddMerchant)}
                            {selectedMerchant && location.pathname === '/' && (
                                <>
                                    {renderButton("Edit", onEdit)}
                                    {renderButton("Delete", onDelete)}
                                    {renderButton("Configuration", onViewConfig)}
                                    {renderButton("Test Connection", onTestConnection)}
                                </>
                            )}
                        </>
                    )}
            </nav>
            <h1>Current Merchants</h1>
            <table>
                <thead>
                <tr>
                    <th className='selection-header'></th>
                    <th>Merchant Account</th>
                    <th>Merchant API Key</th>
                    <th>Report Key</th>
                    <th>Client Key</th>
                    <th>Live endpoint prefix</th>
                </tr>
                </thead>
                <tbody>
                {merchants.map((merchant) => (
                    <MerchantRow
                        key={merchant.merchantId}
                        merchant={merchant}
                        onSelect={setSelectedMerchant}
                        isSelected={selectedMerchant?.merchantId === merchant.merchantId}
                    />
                ))}
                </tbody>
            </table>
        </>
    );
};

const renderButton = (label: string, onClickHandler: () => void) => (
    <button className="btn btn-primary-light" onClick={onClickHandler}>{label}</button>
);

export default MerchantListComponent;
